import {css} from "@pandacss/css";
import {createPandaComponent} from "../helpers/pandaComponent.ts";

const panelClass = css({
    padding: "12px 12px",
    backgroundColor: "neutral.800",
    borderRadius: "16px",
    border: "1px solid",
    borderColor: "neutral.500"
})

const extraVerticalPadding = css({
    paddingTop: "24px",
    paddingBottom: "24px"
});

const Panel = createPandaComponent('Panel', 'div', [panelClass]);
export const PanelExtraVerticalPadding = createPandaComponent('PanelExtraVerticalPadding', 'div', [panelClass, extraVerticalPadding]);

export default Panel;